"use strict";
/**
 * Copyright 2023 actions-toolkit authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bake = void 0;
const buildx_1 = require("./buildx");
const exec_1 = require("../exec");
const inputs_1 = require("./inputs");
const util_1 = require("../util");
class Bake {
    constructor(opts) {
        this.buildx = (opts === null || opts === void 0 ? void 0 : opts.buildx) || new buildx_1.Buildx();
    }
    parseDefinitions(sources, targets, overrides, load, push, workdir) {
        return __awaiter(this, void 0, void 0, function* () {
            const args = ['bake'];
            let remoteDef;
            const files = [];
            if (sources) {
                for (const source of sources.map(v => v.trim())) {
                    if (source.length == 0) {
                        continue;
                    }
                    if (!util_1.Util.isValidRef(source)) {
                        files.push(source);
                        continue;
                    }
                    if (remoteDef) {
                        throw new Error(`Only one remote bake definition is allowed`);
                    }
                    remoteDef = source;
                }
            }
            if (remoteDef) {
                args.push(remoteDef);
            }
            for (const file of files) {
                args.push('--file', file);
            }
            if (overrides) {
                for (const override of overrides) {
                    args.push('--set', override);
                }
            }
            if (load) {
                args.push('--load');
            }
            if (push) {
                args.push('--push');
            }
            const printCmd = yield this.buildx.getCommand([...args, '--print', ...(targets || [])]);
            return yield exec_1.Exec.getExecOutput(printCmd.command, printCmd.args, {
                cwd: workdir,
                ignoreReturnCode: true,
                silent: true
            }).then(res => {
                if (res.stderr.length > 0 && res.exitCode != 0) {
                    throw new Error(res.stderr);
                }
                return JSON.parse(res.stdout.trim());
            });
        });
    }
    static hasLocalExporter(def) {
        return inputs_1.Inputs.hasExporterType('local', Bake.exporters(def));
    }
    static hasTarExporter(def) {
        return inputs_1.Inputs.hasExporterType('tar', Bake.exporters(def));
    }
    static hasDockerExporter(def, load) {
        return load || inputs_1.Inputs.hasExporterType('docker', Bake.exporters(def));
    }
    static exporters(def) {
        const exporters = new Array();
        for (const key in def.target) {
            const target = def.target[key];
            if (target.output) {
                exporters.push(...target.output);
            }
        }
        return exporters;
    }
}
exports.Bake = Bake;
//# sourceMappingURL=bake.js.map